export default () => {
  return (
    <>
      <h1>404</h1>
    </>
  );
};
